// extracted by css-extract-rspack-plugin
export default {"badge":"badge-G6cERz","green":"green-us0L2t","red":"red-afKuIL","blue":"blue-jbwkTG","gray":"gray-oVaq8D"};